import { GenericObject } from './helperTypes';

const snakifyObject = (obj: GenericObject) => Object.entries(obj)
    .reduce((snakedObj, [key, val]) => {
        const newKey = camelToSnake(key);
        if (isObject(val)) {
            snakedObj[newKey] = snakifyObject(val);
        } else if (Array.isArray(val)) {
            snakedObj[newKey] = val.map(snakifyObject);
        } else {
            snakedObj[newKey] = val;
        }
        return snakedObj;
    }, {});

export const camelToSnake = (str: string): string => [...str]
    .reduce((snaked, char) => {
        let str;
        const lower = char.toLowerCase();
        if (lower !== char) {
            str = `${snaked}_${lower}`;
        } else {
            str = `${snaked}${char}`;
        }
        return str;
    }, '');

export const isObject = (obj: any): boolean => !!obj && Object.getPrototypeOf(obj) === Object.prototype;

export default snakifyObject;
